import React from 'react';

interface PageCardProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Tailwind-based card for new pages/components.
 * Existing pages should keep using styled-components from style.ts files.
 */
const PageCard: React.FC<PageCardProps> = ({ children, className = '' }) => (
  <div
    className={`rounded-md bg-white p-6 shadow-[5px_5px_15px_-3px_#BCCCDC] ${className}`}
  >
    {children}
  </div>
);

export default PageCard;
